<template>
  <div>
    <div style="position: relative">
      <h1 class="text-pagename text-xs-center">{{ formTitle }}</h1>
      <v-btn
        icon
        :to="
          '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/storeandproduct/store/' +
            this.$store.state.storeBack.store_detail_id +
            '/product'
        "
        @click="cancelAddProduct()"
        style="position: absolute; left: 0; top: 0"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>
    <v-card>
      <!-- <v-toolbar dark dense> -->

      <!-- <v-icon @click="cancelAddProduct()">close</v-icon> -->
      <!-- </v-toolbar> -->

      <v-card-text style="height: auto; padding: 0" v-if="close_cropper">
        <v-tabs dark v-model="tabs" grow>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="item in lang" :key="item">{{ item }}</v-tab>
        </v-tabs>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout row wrap justify-center>
              <v-flex xs12 md5 class="pr-3 pl-2">
                <v-select
                  :disabled="fetching_data || isEditProductList"
                  :loading="fetching_data == true ? true : false"
                  v-model="form.product_type_id"
                  :items="product_type_item"
                  item-text="product_type_name_th"
                  item-value="product_type_id"
                  label="Product type"
                  :rules="[(v) => !!v || 'type is required']"
                ></v-select>
                <v-tabs-items v-model="tabs">
                  <v-tab-item v-for="n in lang" :key="n">
                    <div style="padding-top: 1px">
                      <v-text-field
                        v-if="n === 'en'"
                        :disabled="fetching_data || isEditProductList"
                        :loading="fetching_data == true ? true : false"
                        @input="upperEn($event)"
                        v-model="form.product_name_en"
                        :label="'Product name (' + n.toUpperCase() + ')'"
                        :rules="
                          form.product_name_en && n == 'en'
                            ? [(v) => !!v || 'name is required', rules.max]
                            : [(v) => !!v || 'name is required']
                        "
                        counter="55"
                      ></v-text-field>

                      <v-text-field
                        v-else-if="n === 'th'"
                        :disabled="fetching_data || isEditProductList"
                        :loading="fetching_data == true ? true : false"
                        @input="upperTh($event)"
                        v-model="form.product_name_th"
                        :label="'Product name (' + n.toUpperCase() + ')'"
                        :rules="
                          form.product_name_th && n == 'th'
                            ? [(v) => !!v || 'name is required', rules.max]
                            : [(v) => !!v || 'name is required']
                        "
                        counter="55"
                      ></v-text-field>
                      <!-- v-model="form['product_name_'+ n]" -->
                      <v-text-field
                        v-else
                        :disabled="fetching_data || isEditProductList"
                        :loading="fetching_data == true ? true : false"
                        @input="upperCn($event)"
                        v-model="form.product_name_cn"
                        :label="'Product name (' + n.toUpperCase() + ')'"
                        :rules="form.product_name_cn ? [rules.max] : []"
                        counter="55"
                      ></v-text-field>
                      <v-textarea
                        :disabled="fetching_data || isEditProductList"
                        :loading="fetching_data == true ? true : false"
                        v-model="form['product_description_' + n]"
                        name="description"
                        label="Description"
                        value
                        rows="1"
                        :rules="
                          form['product_description_' + n]
                            ? [rules.max_description]
                            : []
                        "
                        counter="255"
                      ></v-textarea>
                    </div>
                  </v-tab-item>
                </v-tabs-items>

                <div style="display: flex">
                  <div class="mr-1" style="display: flex; align-items: center">
                    <span style="font-size: 17px; color: #616a6b">Other :</span>
                  </div>
                </div>
                <v-layout row wrap style="margin-bottom: 15px">
                  <v-flex xs6>
                    <v-checkbox
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data == true ? true : false"
                      v-model="form.product_recommend"
                      label="Recommend"
                      color="primary"
                      hide-details
                      style="margin: 0"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data == true ? true : false"
                      v-model="form.product_best_seller"
                      label="Best Seller"
                      color="primary"
                      hide-details
                      style="margin: 0"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs6>
                    <v-checkbox
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data == true ? true : false"
                      v-model="form.product_offer"
                      label="Offer"
                      color="primary"
                      hide-details
                      style="margin: 0"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs4 style="position: relative">
                    <label style="font-size: 17px; color: #616a6b"
                      >Upload Image :</label
                    >
                  </v-flex>
                  <v-flex xs8>
                    <v-btn
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data"
                      @click="$refs.imageInput.click()"
                      small
                      >Choose Files</v-btn
                    >
                    <input
                      style="display: none"
                      type="file"
                      @change="onImageSelected"
                      ref="imageInput"
                      accept="image/*"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <span>{{
                      form.product_image && form.product_image != null
                        ? showImageName
                        : null
                    }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs1 class="text-xs-center hidden-sm-and-down">
                <v-divider vertical></v-divider>
              </v-flex>
              <v-flex xs12 md5 class="pr-3 pl-2">
                <v-layout row>
                  <v-flex xs6 class="mr-2">
                    <v-text-field
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data == true ? true : false"
                      v-model="form.product_pos_sale_price"
                      label="POS sale price"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-text-field
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data == true ? true : false"
                      v-model="form.product_pos_base_price"
                      label="POS base price"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs6 class="mr-2">
                    <v-text-field
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data == true ? true : false"
                      v-model="form.product_sale_price"
                      label="Online sale price"
                      :rules="
                        form.product_sale_price
                          ? [(v) => !!v || 'price is required']
                          : []
                      "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="ml-2">
                    <v-text-field
                      :disabled="fetching_data || isEditProductList"
                      :loading="fetching_data == true ? true : false"
                      v-model="form.product_base_price"
                      label="Online base price"
                      :rules="
                        form.product_base_price
                          ? [(v) => !!v || 'price is required']
                          : []
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-select
                  :disabled="fetching_data || isEditProductList"
                  :loading="fetching_data == true ? true : false"
                  v-model="form.product_status"
                  :items="product_status"
                  item-value="value"
                  item-text="name"
                  label="Product status"
                ></v-select>

                <v-select
                  :disabled="fetching_data || isEditProductList"
                  :loading="fetching_data == true ? true : false"
                  v-model="form.product_approve"
                  :items="approve_status"
                  item-value="value"
                  item-text="name"
                  label="Approve status"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>

        <v-divider class="mx-3"></v-divider>
        <v-card flat class="mt-2">
          <v-flex xs12>
            <v-divider class="mb-3 hidden-md-and-up" />
            <v-toolbar dense flat color="transparent">
              <v-toolbar-title>Option List</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                round
                small
                color="primary"
                class="black--text"
                :disabled="isEditProductList"
                @click="toAddOption()"
              >
                <v-icon>add</v-icon>add option
              </v-btn>
            </v-toolbar>
            <v-card-text class="pt-0">
              <newOptionForm
                :editedIndex="$route.params.isEdit"
                :form_option="form_option"
                @cancel="cancelAddOption()"
                @save="saveAddOption($event)"
                v-if="show_add_option_form == true"
              />
              <optionDetail
                :editedIndex="$route.params.isEdit"
                v-for="(info, index) in form.product_option"
                :key="index"
                :info="info"
                @removeOption="removeOption($event, index)"
              />
            </v-card-text>
          </v-flex>
        </v-card>

        <v-card-actions v-if="$route.params.isEdit != -1">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="fetching_data || isEditProductList"
            :loading="fetching_data"
            color="red"
            flat
            @click="reset()"
            dark
            >reset</v-btn
          >
          <v-btn
            :disabled="fetching_data || isEditProductList"
            :loading="fetching_data"
            color="green"
            depressed
            @click="saveEditInfo()"
            dark
            >Save</v-btn
          >
        </v-card-actions>
      </v-card-text>

      <v-card-text v-else>
        <imageCropper
          :aspectRatio="1 / 1"
          :imageName="image_name"
          :imgSrc="imgSrc"
          :height="300"
          @close="close_cropper = true"
          @setImageName="image_name = $event"
          @getCroped="getCropped($event)"
          v-if="imgSrc != ''"
        />
      </v-card-text>
      <v-divider v-if="close_cropper"></v-divider>
      <v-card-actions v-if="$route.params.isEdit == -1 && close_cropper">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="adding_product"
          color="red"
          flat
          @click="cancelAddProduct()"
          >Cancel</v-btn
        >
        <v-btn
          :disabled="adding_product || isEditProductList"
          color="green"
          @click="saveProduct()"
          depressed
          class="white--text"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import imageCropper from "@/components/Plugins/imageCropper.vue";
import newOptionForm from "@/components/back-office/InStore/ProductManagement/ProductList/NewOptionForm";
import optionDetail from "@/components/back-office/InStore/ProductManagement/ProductList/OptionDetail";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    imageCropper,
    newOptionForm,
    optionDetail,
  },
  data() {
    return {
      adding_product: false,
      fetching_data: false,
      original_data: {},
      form: {},
      close_cropper: true,
      img_name: "",
      imgSrc: "",
      change_image: 0,
      form_option: {},
      image_name: "",
      show_add_option_form: false,
      valid: true,
      rules: {
        max: (value) =>
          value.length <= 55 || "Maximum length is 55 characters.",
        max_description: (value) =>
          value.length <= 255 || "Maximum length is 255 characters.",
      },
      product_status: [
        {
          name: "Active",
          value: true,
        },
        {
          name: "Inactive",
          value: false,
        },
      ],
      approve_status: [
        {
          name: "Online",
          value: 2,
        },
        {
          name: "Offline",
          value: 0,
        },
      ],
      product_name: "",
      base_price: "",
      sale_price: "",
      tabs: 0,
      lang: ["th", "en", "cn"],
    };
  },
  destroyed() {
    if (this.$route.name != "storeproductlist") {
      this.$store.commit("fetchProductListBack/resetState");
      this.$store.commit("fetchProductTypeBack/resetState");
    }
  },
  computed: {
    ...mapState({
      product_type_item: (state) =>
        state.fetchProductTypeBack.product_type_list,
      store_detail_id: (state) => state.storeBack.store_detail_id,
    }),
    ...mapGetters(["isEditProductList"]),
    showImageName() {
      if (this.$route.params.isEdit != -1 && this.image_name == "") {
        let name = this.form.product_image.split("/");
        this.image_name = name[name.length - 1];
        this.form.product_image = null;
      }

      return this.image_name;
    },
    formTitle() {
      return this.$route.params.isEdit == -1 ? "New Product" : "Edit Product";
    },
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
      }
    },
  },
  methods: {
    setForm() {
      this.form = {
        product_code: null,
        product_image: null,
        product_name_th: "",
        product_description_th: "",
        product_name_en: "",
        product_description_en: "",
        product_name_cn: "",
        product_description_cn: "",
        product_pos_sale_price: 0,
        product_pos_base_price: 0,
        product_sale_price: 0,
        product_base_price: 0,
        product_note: null,
        product_type_id: 0,
        product_recommend: false,
        product_best_seller: false,
        product_approve: 0,
        product_status: false,
        product_store_id: this.store_detail_id,
        product_option: [],
      };
    },
    upperEn(val) {
      this.form.product_name_en = val.toUpperCase();
    },
    upperTh(val) {
      this.form.product_name_th = val.toUpperCase();
    },
    upperCn(val) {
      this.form.product_name_cn = val.toUpperCase();
    },
    async removeOption(option_info, index) {
      if (option_info.option_id) {
        let checkSuccess = await this.$store.dispatch(
          "fetchProductListBack/delOption",
          option_info.option_id
        );
        if (checkSuccess == true) {
          this.form.product_option.splice(index, 1);
        }
      } else {
        this.form.product_option.splice(index, 1);
      }
    },
    reset() {
      let resetForm = JSON.parse(JSON.stringify(this.original_data));
      delete resetForm.product_option;
      Object.assign(this.form, resetForm);
      this.image_name = "";
    },
    async saveEditInfo() {
      if (this.$refs.form.validate()) {
        let sendForm = Object.assign({}, this.form);
        delete sendForm.product_option;
        if (this.change_image == 0) {
          delete sendForm.product_image;
        }
        sendForm = await this.stringEmptyToNull(sendForm);
        this.$emit("setFetchingData", true);
        let checkSuccess = await this.$store.dispatch(
          "fetchProductListBack/editProduct",
          sendForm
        );
        this.$emit("setFetchingData", false);
        if (checkSuccess == true) {
          this.form.product_image = null;
          this.image_name = "";
          this.$router.push({
            path:
              "/weserve_admin_login/control/" +
              this.$store.state.backOffice.province +
              "/storeandproduct/store/" +
              this.$store.state.storeBack.store_detail_id +
              "/product",
          });
          this.cancelAddOption();
        } else {
          this.reset();
        }
      }
    },
    setFormOption() {
      this.form_option = {
        option_choice: [
          {
            choice_name_th: null,
            choice_name_en: null,
            choice_name_cn: null,
            choice_price: null,
          },
        ],
      };
    },
    getCropped(image_value) {
      this.form.product_image = image_value;
      this.change_image = 1;
      this.imgSrc = "";
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imgSrc = reader.result;
        this.close_cropper = false;
      });
      reader.readAsDataURL(file);
    },
    cancelAddOption() {
      this.show_add_option_form = false;
      this.setFormOption();
    },
    saveAddOption(data) {
      this.show_add_option_form = false;
      if (this.$route.params.isEdit == -1) {
        this.form.product_option.push(this.form_option);
      } else {
        this.form.product_option.push(data);
      }
      this.setFormOption();
    },
    toAddOption() {
      this.show_add_option_form = true;
      if (this.$route.params.isEdit != -1) {
        this.form_option.option_product_id = this.form.product_id;
      }
    },
    stringEmptyToNull(form) {
      for (let val in form) {
        if (typeof form[val] == "string" && form[val] == "") {
          form[val] = null;
        }
        if (typeof form[val] == "object" && form[val] != null) {
          for (let arr in form[val]) {
            for (let val1 in form[val][arr]) {
              if (
                typeof form[val][arr][val1] == "string" &&
                form[val][arr][val1] == ""
              ) {
                form[val][arr][val1] = null;
              }
              if (
                typeof form[val][arr][val1] == "object" &&
                form[val][arr][val1] != null
              ) {
                for (let arr2 in form[val][arr][val1]) {
                  for (let val2 in form[val][arr][val1][arr2]) {
                    if (
                      typeof form[val][arr][val1][arr2][val2] == "string" &&
                      form[val][arr][val1][arr2][val2] == ""
                    )
                      form[val][arr][val1][arr2][val2] = null;
                  }
                }
              }
            }
          }
        }
      }
      return form;
    },
    async saveProduct() {
      if (this.$refs.form.validate()) {
        if (this.change_image == 0) {
          delete this.form.product_image;
        }
        this.adding_product = true;
        this.form = await this.stringEmptyToNull(this.form);
        let check = await this.$store.dispatch(
          "fetchProductListBack/addProductList",
          this.form
        );
        this.adding_product = false;
        if (check != false) {
          this.image_name = "";
          this.$router.push({
            path:
              "/weserve_admin_login/control/" +
              this.$store.state.backOffice.province +
              "/storeandproduct/store/" +
              this.$store.state.storeBack.store_detail_id +
              "/product",
          });
        }
      }
    },
    cancelAddProduct() {
      this.image_name = "";
      //   this.$emit("setDialog", false);
      //   this.$emit("setEditIndex", -1);
      this.cancelAddOption();
    },
    async fetchData() {
      this.form = {
        product_name_th: "",
        product_description_th: "",
        product_name_en: "",
        product_description_en: "",
        product_name_cn: "",
        product_description_cn: "",
      };
      this.fetching_data = true;
      if (this.store_detail_id == null) {
        let store_detail = await this.$store.dispatch(
          "fetchStoreBack/getStoreDetail",
          this.$route.params.store_id
        );
        this.$store.commit(
          "storeBack/setStoreDetailId",
          store_detail.store.store_id
        );
        await this.$store.dispatch("fetchProductTypeBack/getData");
      }
      let get_data = await this.$store.dispatch(
        "fetchProductListBack/getProductDetail",
        this.$route.params.productid
      );
      this.fetching_data = false;
      this.original_data = Object.assign({}, get_data);
      this.form = get_data;
    },
  },
  created() {
    this.setForm();
    if (this.$route.params.isEdit != -1) {
      this.fetchData();
    }

    this.change_image = 0;
    this.setFormOption();
  },
};
</script>
